import { getDownloadURL, uploadBytesResumable } from 'firebase/storage';

export const uploadFileAndGetUrl = (storageRef, file) => new Promise((resolve, reject) => {
  const metadata = file?.type ? { contentType: file.type } : undefined;
  const uploadTask = uploadBytesResumable(storageRef, file, metadata);

  uploadTask.on(
    'state_changed',
    undefined,
    reject,
    async () => {
      try {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve({ snapshot: uploadTask.snapshot, url });
      } catch (error) {
        reject(error);
      }
    }
  );
});
